module.exports = __webpack_public_path__ + "img/13.07a63de0.png";